var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PcContain",staticStyle:{"overflow":"auto"}},[_c('CommonHeader',{on:{"searchFun":_vm.searchFun}}),_vm._v(" "),_c('div',{staticClass:"layout",style:({minHeight:_vm.totalTip == 'special'?'400px':'600px'})},[_c('router-view',{ref:"servicePageSearch"})],1),_vm._v(" "),_c('CommonFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46588186","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/todoCenter/default/workflow/layout/index.vue
// module id = C3c5
// module chunks = 16